module.exports = __webpack_public_path__ + "media/images/client/favicons/icon-512x512-a7b78902eeff42609b80cce5278f59d0.png";